export interface TagScheduleFormData {
  brands: Array<string>;
  regions: Array<string>;
  activeStartDate: string | null;
  activeEndDate: string | null;
  travelStartDate: string | null;
  travelEndDate: string | null;
}

export const TAG_SCHEDULE_DEFAULT_VALUES: TagScheduleFormData = {
  brands: ['luxuryescapes'],
  regions: [],
  activeStartDate: null,
  activeEndDate: null,
  travelStartDate: null,
  travelEndDate: null,
};

export function getTagScheduleFormValues(schedule?: Partial<TagScheduleFormData>): TagScheduleFormData {
  return {
    ...TAG_SCHEDULE_DEFAULT_VALUES,
    ...schedule,
  };
}

export function validateTagScheduleFormData(data: TagScheduleFormData): string | null {
  if (!data.activeStartDate || !data.activeEndDate) {
    return 'Please select both active period start and end dates';
  }

  if (data.activeStartDate > data.activeEndDate) {
    return 'Active period start date must be before end date';
  }

  if (data.travelStartDate && data.travelEndDate && data.travelStartDate > data.travelEndDate) {
    return 'Travel period start date must be before end date';
  }

  if (data.regions.length === 0) {
    return 'Please select at least one region';
  }

  return null;
}
